import React from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { ChangePersonalAddressType } from '../logic/ChangePersonalAddressSchema';
import { useChangeAddressStepHook } from '../logic/useStepHook';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit_pen_icon.svg';

export interface FormViewProps {
  handleClick: () => void;
  handleEdit: () => void;
  isLoading?: boolean;
}

export const EditView = ({ handleClick, handleEdit, isLoading }: FormViewProps) => {
  const { isValid } = useFormState();
  const { getValues } = useFormContext();
  const values = getValues() as ChangePersonalAddressType;
  const { t } = useChangeAddressStepHook({});
  const buttonTitle = t('CHANGE_ADDRESS.EDIT.BUTTON_TITLE');
  const valuesString = JSON.stringify(values);
  const textSize = valuesString.length > 140 ? 'text-[18px]' : valuesString.length > 125 ? 'text-[26px]' : 'text-[28px]';

  return (
    <div className='flex flex-col items-center justify-center w-[440px] pt-[76px]'>
      <div className='min-w-[410px] pb-[108px]'>
        <div className='flex flex-col'>
          <p className={`text-bw08 font-medium font-metricR  ${textSize} break-words  w-full text-center mb-[5px]`} id='values1'>
            {values.street}
            ,
            {' '}
            {values.apt && ` ${values.apt}`}
          </p>
          <p className={`text-bw08 font-medium font-metricR  ${textSize} w-full text-center mb-[5px]`} id='values2'>
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            {values.city}, {values.state}, {values.zip}
          </p>
        </div>
        <button
          type='button'
          className='btn btn-link pt-6 flex items-center justify-center'
          id='editButton'
          onClick={() => handleEdit()}
        >
          <EditIcon className='mr-2 hover:color-action03' />
          {t('CHANGE_ADDRESS.EDIT.EDIT_BUTTON')}
        </button>
      </div>

      <LiliButton
        id='address-submit'
        title={buttonTitle}
        disabled={!isValid}
        isLoading={isLoading}
        onClick={() => handleClick()}
        type={LiliButtonType.PRIMARY}
        className='w-[440px] h-[44px]'
      />
    </div>
  );
};
